import { EFFECT_LEVEL } from '../../enums/index';

/**
* 副作用 用于表明node的操作
* 会被推入EffectQueue队列 flushEffect时候被一次性执行
*/
class EffectBase {
  /**
   * 构造函数
   * @param {*} param0 
   * level flushEffect时优先级枚举
   * 高优先级会直接执行 低优先级会被推入LongTask下队列 在浏览器空闲时间片时执行
   * 目前只有在支持requestIdleCallback的浏览器可得到优化 不兼容降级为全高优先级同步执行
   * 
   * flag 副作用类型 移动 还是 删除 或 仅更新数据
   * payload 副作用具体参数 eg: { x: 100, y: 100 }
   * callBack 执行完会被调用的函数
   */
  constructor({ flag, level, payload, callBack }) {
    this.flag = flag;
    this.payload = payload;
    this.level = level || EFFECT_LEVEL.HEIGH; // 默认高优先级
    this.callBack = callBack;
  }
}

export default EffectBase;